<h1>
  {{ siteAnnouncement.title }}
</h1>
<div class="date">
  <span>
    {{ siteAnnouncement.publish_date | date: 'MMM d, y' }}
  </span>
</div>

<gb-quill-text [html]="siteAnnouncement.content"></gb-quill-text>
